import { MutationTree } from 'vuex';
import { SkillProf, SkillProfState } from './learner-types';

const mutations: MutationTree<SkillProfState> = {
  SkillProfInState(state, payload: SkillProf) {
    state.error = false;
    state.skillprof = payload;
  },

  SkillProfError(state) {
    state.error = true;
    state.skillprof = undefined;
  },
};

export default mutations;
